import React from 'react';
import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';
export default class SellerGroupModelListGroupSelection extends React.Component {
    constructor(props) {
        super(props);
        this.changeGroup = (e) => {
            console.log(`selected group is: ${e.target.id}`);
            let nullIdIfEmptyValue = e.target.id ? e.target.id : null;
            this.props.changeGroup(nullIdIfEmptyValue);
        };
        let groups = this.props.groups;
        this.state = {
            currentActiveGroup: groups ? groups[0].sellerProductGroupId : null,
        };
    }
    handleSelect(eventKey) {
        console.log(`selected group is: ${eventKey}`);
        let nullIdIfEmptyValue = eventKey ? eventKey : null;
        this.setState({
            currentActiveGroup: eventKey,
        });
        this.props.changeGroup(nullIdIfEmptyValue);
    }
    render() {
        let groups = this.props.groups;
        const groupSelections = groups.map((group, index) => (React.createElement(Nav.Item, { key: group.sellerProductGroupId },
            React.createElement(Nav.Link, { eventKey: group.sellerProductGroupId }, group.sellerProductGroupName))));
        return (React.createElement(Nav, { variant: "pills", onSelect: (k) => this.handleSelect(k), activeKey: this.state.currentActiveGroup }, groupSelections));
    }
}
SellerGroupModelListGroupSelection.propTypes = {
    groups: PropTypes.array.isRequired,
};
